import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonIconStatus } from 'src/app/enums/button-icon-status.enum';
import { ButtonTypes } from '../../../enums/button-type.enum';
import { Button } from '../../../models/button.model';

@Component({
  selector: 'lns-filter-transactions',
  templateUrl: './filter-transactions.component.html',
  styleUrls: ['./filter-transactions.component.scss']
})
export class FilterTransactionsComponent {
  @Output() applyHandler = new EventEmitter();
  cancelButton: Button = {
    type: ButtonTypes.TransparentGrayText
  };
  applyButton: Button = {
    iconName: 'arrow_right',
    iconState: ButtonIconStatus.After,
    iml: '8'
  };

  constructor(private router: Router, private route: ActivatedRoute) {}

  applyFilter(): void {
    this.applyHandler.emit();
  }

  openPicker(elementId: any) {
    let el = document.getElementById(elementId) as HTMLFormElement
    el.showPicker()
  }

  onBack(): void {
    this.router.navigate(['../'], { relativeTo: this.route });
  }
}
